/**
 * Bootstrap permissions administrator (no group required for Permissions UI only).
 * Backend should mirror this email in PermissionController / auth middleware.
 */

export const PERMISSIONS_SUPER_ADMIN_EMAIL = "superadmin@superadmin.com";

function readSessionUser() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function normalizeEmail(email) {
  return String(email || "").trim().toLowerCase();
}

/** True when the logged-in user is the fixed permissions super-admin account. */
export function isPermissionsSuperAdmin() {
  const user = readSessionUser();
  if (!user) return false;
  const email = user.email ?? user.user_email ?? user.login ?? "";
  return normalizeEmail(email) === PERMISSIONS_SUPER_ADMIN_EMAIL;
}

/** Minimal flags for super-admin when they have no permission group yet. */
export function buildSuperAdminOnlyPermissionFlags() {
  return { permissions_page: 1 };
}
